import React from "react";
import { useNavigate } from "react-router-dom";
import "../../src/index.css";
import "../components/styles/header.css";
import logo from "../img/LogoPrincipal.png";
import whatsappIcon from "../assets/whatsapp-icon.svg";
import { useState, useEffect } from "react";

const Header = () => {
  const [isActive, setIsActive] = useState(false);
  const [menuListActive, setMenuListActive] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      const menuList = document.querySelector(".menu-list");
      const mobileMenu = document.querySelector(".mobile-menu");
      if (
        menuList &&
        !menuList.contains(event.target) &&
        !mobileMenu.contains(event.target)
      ) {
        setMenuListActive(false);
        setIsActive(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleMenuClick = () => {
    setMenuListActive(!menuListActive);
    setIsActive(!isActive);
  };

  const handleLinkClick = (path) => {
    setIsActive(false);
    setMenuListActive(false);
    navigate(path);
    // Scroll para o topo após navegação
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  const animateLinks = (open) => {
    const navLinks = document.querySelectorAll(".menu-list li");
    navLinks.forEach((link, index) => {
      if (open) {
        link.style.animation = `navLinkFade 0.5s ease forwards ${
          index / 7 + 0.3
        }s`;
      } else {
        link.style.animation = "none";
      }
    });
  };

  useEffect(() => {
    if (isActive) {
      setTimeout(() => animateLinks(true), 10);
    } else {
      animateLinks(false);
    }
  }, [isActive]);

  return (
    <header className="header">
      <nav>
        {/* Logo */}
        <div className="header-logo">
          <button className='logo-button' onClick={() => handleLinkClick('/')}>
            <img src={logo} alt="Logo" />
          </button>
        </div>

        <div className="mobile-menu-container">
          {/* Menu Hamburguer */}
          <div
            className={`mobile-menu ${isActive ? "active" : ""}`}
            onClick={handleMenuClick}
          >
            <div className="line1"></div>
            <div className="line2"></div>
            <div className="line3"></div>
          </div>

          {/* Navegação */}
          <div className="header-navigation">
            <ul className={`menu-list ${menuListActive ? "active" : ""}`}>
              <li>
                <button className="nav-link" onClick={() => handleLinkClick('/')}>
                  Home
                </button>
              </li>
              <li>
                <button className="nav-link" onClick={() => handleLinkClick('/pricing')}>
                  Price & Packages
                </button>
              </li>
              <li>
                <button className="nav-link" onClick={() => handleLinkClick('/how-it-works')}>
                  How it Works
                </button>
              </li>
              <li className="mobile-only">
                <button
                  className="nav-link"
                  onClick={() => {
                    setIsActive(false);
                    setMenuListActive(false);
                    window.open('https://wa.me/14076932200');
                  }}
                >
                  WhatsApp
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Botão de Contato */}
        <div className="header-contact">
          <a 
            href="https://wa.me/14076932200" 
            target="_blank" 
            rel="noopener noreferrer"
            className="contact-button"
          >
            <span>Contact</span>
            <img src={whatsappIcon} alt="WhatsApp" />
          </a>
        </div>
      </nav>
    </header>
  );
};

export default Header;